import * as React from "react";
import {connect} from "react-redux";
import {Panel, Row, Col, Alert} from "react-bootstrap";
import {FormGroup, FormControl, ControlLabel, Button} from "react-bootstrap";
import {ApplicationState} from "../../reducers";
import {login, SecurityAction} from "../../actions/security";
import {SecurityState} from "../../reducers/security";
import {Loading} from "../Loading";

interface LoginState {
    username: string;
    password: string;
}

interface LoginProps extends SecurityState {
    login: (username: string, password: string) => Promise<SecurityAction>;
}

class Login extends React.Component<LoginProps, LoginState> {
    public constructor(props: LoginProps) {
        super(props, null);
        this.state = {
            username: "",
            password: ""
        };
    }
    public render(): JSX.Element {
        const {loading} = this.props;
        return (
            <div>
                {this.props.errorMessage && <Alert bsStyle="danger">{this.props.errorMessage}</Alert>}
                <Row style={{marginTop: "100px"}}>
                    <Col xs={0} lg={3} />
                    <Col xs={12} lg={6}>
                        <Panel>
                            <Panel.Heading>Parksavers Administrative Login</Panel.Heading>
                            <Panel.Body>
                                <form onSubmit={(e) => this.login(e)}>
                                    <Row>
                                        <Col xs={12}>
                                            <FormGroup controlId="username">
                                                <ControlLabel>Username</ControlLabel>
                                                <FormControl type="text"
                                                             placeholder="Username"
                                                             value={this.state.username}
                                                             onChange={(e: any) => this.setState({username: e.target.value})}/>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            <FormGroup controlId="password">
                                                <ControlLabel>Password</ControlLabel>
                                                <FormControl type="password"
                                                             placeholder="Password"
                                                             value={this.state.password}
                                                             onChange={(e: any) => this.setState({password: e.target.value})}/>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {loading && <Loading/>}
                                        <Col xs={12} style={{textAlign: "right"}}>
                                            <Button type="submit" disabled={loading} bsStyle="primary">Login</Button>
                                        </Col>
                                    </Row>
                                </form>
                            </Panel.Body>
                        </Panel>
                    </Col>
                    <Col xs={0} lg={3} />
                </Row>
            </div>
        );
    }

    private login(evt: React.FormEvent<HTMLFormElement>) {
        evt.preventDefault();
        const {username, password} = this.state;
        if (!(username && password)) {
            return;
        }
        this.props.login(username, password);
    }
}

const connected = connect(
    (state: ApplicationState) => ({...state.security}),
    {login}
)(Login);

export default connected;



// WEBPACK FOOTER //
// ./src/components/admin/Login.tsx